
import dotProp from 'dot-prop-immutable'

import * as actions from '../actionTypes'


const initialState = {
  availableDecisions: {},
  reRunDecisions: false,
  initiateSession: {
    isRequestingDecisions: false,
    isRequestingInitialization: false,
    isValidating: false,
    errors: {
      caseIdUniqueness: false,
      apiErrorText: null
    }
  }
}

const setup = (state = initialState, action) => {
  switch(action.type) {
    case actions.CASE_ID_VALIDATION_FAILURE:
      return dotProp.set(state, 'initiateSession', {
        isValidating: false,
        errors: {caseIdUniqueness: true}
      })
    case actions.CASE_ID_VALIDATION_SUCCESS:
      return dotProp.set(state, 'initiateSession', {
        isValidating: false,
        errors: {caseIdUniqueness: false}
      })
    case actions.CASE_ID_VALIDATION_REQUESTED:
      return dotProp.set(state, 'initiateSession', {
        isValidating: true,
        errors: {caseIdUniqueness: false}
      })
    case actions.CLEAR_CASE_ID_ERRORS:
      return dotProp.set(state, 'initiateSession.errors', {
        caseIdUniqueness: false
      })
    case actions.DECISIONS_REQUESTED:
      return dotProp.set(state, 'initiateSession.isRequestingDecisions', true)
    case actions.DECISIONS_REQUESTED_FAILURE:
      return dotProp.set(state, 'initiateSession.isRequestingDecisions', false)
    case actions.DECISIONS_REQUESTED_SUCCESS:
      if (state.reRunDecisions) {
        state = dotProp.set(state, 'reRunDecisions', false)
      }
      state = dotProp.merge(state, 'availableDecisions', action.payload)
      return dotProp.set(state, 'initiateSession.isRequestingDecisions', false)
    case actions.SESSION_INITIALIZE_FAILURE:
      const { errorText } = action.payload.error
      if (errorText) state = dotProp.set(state, 'initiateSession.errors.apiErrorText', errorText)
      return dotProp.set(state, 'initiateSession.isRequestingInitialization', false)
    case actions.SESSION_INITIALIZE_REQUESTED:
      state = dotProp.set(state, 'initiateSession.errors.apiErrorText', null)
      return dotProp.set(state, 'initiateSession.isRequestingInitialization', true)
    case actions.SESSION_INITIALIZE_SUCCESS:
      state = dotProp.set(state, 'reRunDecisions', true)
      return dotProp.set(state, 'initiateSession.isRequestingInitialization', false)
    case actions.SESSION_INITIALIZE_CLEAR_ERROR:
      return dotProp.set(state, 'initiateSession.errors.apiErrorText', null)
    case actions.SET_RERUN_DECISIONS:
      return dotProp.set(state, 'reRunDecisions', action.payload)
    case actions.SESSION_NAVIGATION:
      return {
        ...state,
        form: {
          ...state.form,
          ...action.payload
        }
      }
    default:
      return state
  }
}

export default setup



// WEBPACK FOOTER //
// ./src/reducers/setup.js